import React, { useEffect, useState } from 'react';
import "./SimpleBookmark.css";
import IOSSpinner from '../../../HtmlElements/IOSSpinner';
import ResizableDivForTag from '../../uiUtils/resizeobs/ResizableDivForTag';
import * as FeatherIcon from "react-feather";
import { useUser } from '../../../../context/UserContext';

function SimpleBookmark({ isFilled = false, customCallback=async()=>{}, users=[], countOnly=false, showSingle=false }) {
  const [loading,setLoading]=useState(false)

  const {user} = useUser();

  const [userList, setUserList] = useState(users)

  // const getListTags = (my_data,idx) => {
  //   const tabConfig =  my_data.map((item)=>( {
  //       key:idx,
  //       label: <FeatherIcon.Users alt="users" style={{color:"#4B84E9" , maxHeight:"1.1rem"}} className="mr-1"/> + " "+ item
  //     })
  //   )
  //   return <ResizableDivForTag handleSideCard={() => {}} items={tabConfig} rowData={{}} />

  //   // return <TagOverflowHandler  handleSideCard={()=>null} tabConfig={tabConfig} rowData={{}} showMinimumCount={2} />
  // }

  const getListTags = (my_data, idx) => {
    const tabConfig = my_data.map((item, i) => ({
      key: `${idx}-${i}`, // unique key
      label: (
        <>
          <FeatherIcon.Users 
            alt="users" 
            style={{ color: "#4B84E9", maxHeight: "13px" }} 
            className="" 
          />
          {item?.firstname} {item?.lastname}
        </>
      )
    }));

    return (
      <ResizableDivForTag 
        handleSideCard={() => {}} 
        items={tabConfig} 
        rowData={{}} 
        countOnly={true}
      />
    );
  };

  useEffect(() => {
    let user_temp = {
      firstname: user?.firstname,
      lastname: user?.lastname,
    };

    if (isFilled === true) {
      setUserList((prev) => {
        const exists = prev.some(
          (u) => u.firstname === user_temp.firstname && u.lastname === user_temp.lastname
        );
        if (exists) return prev;
        return [...prev, user_temp];
      });
    } else {
      setUserList((prev) =>
        prev.filter(
          (u) => !(u.firstname === user_temp.firstname && u.lastname === user_temp.lastname)
        )
      );
    }
  }, [isFilled]);
  
  return (
    <>
    <div className={`bookmark_icon ${isFilled ? 'filled' : 'outline'}`} 
>
      {loading ? <IOSSpinner/>:<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"     onClick={async(e)=>{
      setLoading(true)
      e.preventDefault();
      e.stopPropagation();
      await customCallback();
      setLoading(false)
    }}>
        <path
          d="M10.6677 13L6.00105 9.66667L1.33438 13V2.33333C1.33438 1.97971 1.47486 1.64057 1.72491 1.39052C1.97495 1.14048 2.31409 1 2.66771 1H9.33438C9.688 1 10.0271 1.14048 10.2772 1.39052C10.5272 1.64057 10.6677 1.97971 10.6677 2.33333V13Z"
          fill={isFilled ? "#4E6BCA" : "none"}
          stroke="#9898A1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>}
    </div>

    <div className='bookmark-cnt' style={{
      whiteSpace: 'nowrap'
    }}>
      {getListTags(userList)}
    </div>
    </>
  );
}

export default SimpleBookmark;
